import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navigation({ onOpenForm }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "O que é", href: "#what-is" },
    { label: "Como funciona", href: "#how-works" },
    { label: "Diferenciais", href: "#differentials" },
    { label: "Investimento", href: "#pricing" },
    { label: "Conhecimento", href: "/conhecimento" },
    { label: "Licenciamento e Renovações", navLabel: "Licenciamento", href: "/licenciamento-renovacoes" },
    { label: "Contato", href: "#contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#0F1115]/95 backdrop-blur-md border-b border-[#2A2F38]" : "bg-transparent"
      }`}
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2" data-testid="nav-logo">
            <span className="font-heading text-2xl md:text-3xl font-bold text-[#F59E0B]">
              Kp<span className="text-[#E5E7EB]">Action</span>
            </span>
          </a>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-4 xl:gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-xs xl:text-sm font-medium text-[#9CA3AF] hover:text-[#F59E0B] transition-colors uppercase tracking-wide whitespace-nowrap"
                data-testid={`nav-link-${link.href.replace("#", "").replace("/", "")}`}
              >
                {link.navLabel || link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              onClick={onOpenForm}
              className="bg-[#F59E0B] text-black font-bold uppercase tracking-wide hover:bg-[#D97706] transition-all rounded-sm px-6 py-2 text-sm shadow-glow hover:shadow-glow-strong"
              data-testid="nav-cta-button"
            >
              Testar Grátis
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#E5E7EB] p-2"
            data-testid="mobile-menu-button"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#1C1F26] border border-[#2A2F38] rounded-sm mb-4" data-testid="mobile-menu">
            <div className="flex flex-col p-4 gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-sm font-medium text-[#9CA3AF] hover:text-[#F59E0B] transition-colors uppercase tracking-widest py-2"
                >
                  {link.label}
                </a>
              ))}
              <Button
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  onOpenForm();
                }}
                className="bg-[#F59E0B] text-black font-bold uppercase tracking-wide hover:bg-[#D97706] transition-all rounded-sm px-6 py-3 text-sm mt-2"
                data-testid="mobile-cta-button"
              >
                Testar Grátis
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
